import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

/** Sur-titre mono uppercase (12px, 0.12em) - token V2 `.eyebrow`. */
export function Eyebrow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-block font-mono text-[12px] font-semibold uppercase tracking-[0.12em] text-[var(--v2-ink-3)]',
        className,
      )}
    >
      {children}
    </span>
  )
}
